export default function CopyrightController(
    scrollService
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        scrollToTop,
    });

    function scrollToTop() {
        scrollService.scrollToTop();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/main/controllers/copyrightController.js